export enum UserRoles {
  root = "root",
  admin = "admin",
  bar = "bar",
  meta = "meta",
  restaurant = "restaurant",
  reception = "reception",
  operator = "operator",
  editor = "editor",
}

export enum GuestRules {
  tvuser = "tvuser",
  tabuser = "tabuser",
  user = "user",
  signuser = "signuser",
  admin = "admins",
}
